import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { DrawerStateService } from '../../core/services/drawer-state.service';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { AppMenuComponent } from '../navigation-menu/app.menu.component';
import { AppTopBarComponent } from '../topbar/app.topbar.component';
import { SessionTimeoutComponent } from '@app-layout/session-timeout';
@Component({
  selector: 'app-main',
  templateUrl: './app.main.component.html',
  styleUrls: ['./app.main.component.css'],
  imports: [
    Bind,
    Button,
    AppMenuComponent,
    AppTopBarComponent,
    SessionTimeoutComponent
  ]
})
export class AppMainComponent implements OnInit, OnDestroy {
  private drawerStateService = inject(DrawerStateService);

  // Expose signals to template
  protected sidebarExpanded = this.drawerStateService.expanded;
  protected sidebarPinned = this.drawerStateService.pinned;
  protected isMobile = this.drawerStateService.isMobile;

  // Home link (could be computed from auth state)
  protected homeLink = '/';

  ngOnInit(): void {
    // Initialize responsive detection
    this.drawerStateService.initializeResponsiveDetection();
  }

  onSidebarMouseEnter(): void {
    // Expand sidebar on hover (unless on mobile)
    if (!this.isMobile()) {
      this.drawerStateService.expand();
    }
  }

  onSidebarMouseLeave(): void {
    // Auto-collapse sidebar when mouse leaves (only if not pinned and not mobile)
    if (!this.sidebarPinned() && !this.isMobile()) {
      this.drawerStateService.collapse();
    }
  }

  toggleSidebarPin(): void {
    this.drawerStateService.togglePin();
  }

  ngOnDestroy(): void {
    this.drawerStateService.cleanup();
  }
}
